import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { getActiveClientsAsync } from "../../../api/Dashboard";
import { useDatoPanel } from "../useDatoPanel";
import KpiPanel from "./KpiPanel";

const ClientCount = () => {
  const [activeClients, setActiveClients] = useState(0);
  const { cargando, error, recargar } = useDatoPanel(
    getActiveClientsAsync,
    (data) => setActiveClients(data.result)
  );

  return (
    <KpiPanel
      titulo="Clientes Activos"
      valor={activeClients}
      formato="entero"
      icono={<FontAwesomeIcon icon={faUsers} style={{ fontSize: 22 }} />}
      tono="primary"
      cargando={cargando}
      error={error}
      onReintentar={recargar}
      destino="/clients"
      permiso="CLIENTS VER"
      ayuda="Ver Clientes"
    />
  );
};

export default ClientCount;
